var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.583,
    height: 15.761,
    viewBox: "0 0 21.583 15.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-youtube",
    "data-name": "Icon feather-youtube",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M20.672,8.154a2.474,2.474,0,0,0-1.727-1.78A64.1,64.1,0,0,0,11.291,6s-6.124,0-7.655.409A2.474,2.474,0,0,0,1.909,8.19,25.813,25.813,0,0,0,1.5,12.9a25.813,25.813,0,0,0,.409,4.744,2.474,2.474,0,0,0,1.727,1.709c1.531.409,7.655.409,7.655.409s6.124,0,7.655-.409a2.474,2.474,0,0,0,1.727-1.78,25.812,25.812,0,0,0,.409-4.673,25.812,25.812,0,0,0-.409-4.744Z",
    transform: "translate(-1.499 -6)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M14.625,18.541l5.118-2.911L14.625,12.72Z",
    transform: "translate(-6.836 -8.732)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.ab6e1fdd1479fd949b271f6d0c3a8284.svg";
export { ForwardRef as ReactComponent };